export default "__VITE_ASSET__Z3fs0rri__"